import styled from 'styled-components';
import { Edit, Checkmark } from '@carvana/icons';

export const EditField = styled.div`
  display: flex;
  margin-left: auto;
  cursor: pointer;
  color: ${(props: any) => props.theme.carvana.blue.primary};
  :hover span {
    color: ${(props: any) => props.theme.carvana.blue.hover};
  }
`;

export const CheckmarkIcon = styled(Checkmark)`
  color: ${(props: any) => props.theme.carvana.blue.primary};
  background: ${(props: any) => props.theme.carvana.gray.background};
  border: 1px solid ${(props: any) => props.theme.carvana.blue.primary};
  border-radius: 3px;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  > svg {
    height: 10px;
    width: 10px;
  }
`;

export const MailingAddressCopy = styled.p`
  font-size: 14px;
  color: ${(props: any) => props.theme.carvana.gray.dark};
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
`;

export const EditText = styled.span`
  display: flex;
  align-items: center;
  margin-left: 0.9em;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
`;

export const EditIcon = styled(Edit)`
  > svg {
    height: 15px;
    width: 15px;
    margin-top: 0.38em;
  }
`;

export const Title = styled.h3`
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  color: ${(props: any) => props.theme.carvana.blue.dark};
`;

export const Heading = styled.div`
  border-bottom: 1px ${(props: any) => props.theme.carvana.gray.light} solid;
  padding-bottom: 0.8em;
  margin-bottom: 1.6em;
`;

export const Section = styled.div``;

export const Field = styled.div`
  display: flex;
  margin-bottom: 1em;
`;

export const Label = styled.div`
  color: ${(props: any) => props.theme.carvana.blue.dark};
  flex: 1;
`;
export const Value = styled.div`
  display: flex;
  flex: 2;
  justify-content: space-between;
  color: ${(props: any) => props.theme.carvana.gray.dark};
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-flow: column;
  width: 100%;

  ${Heading} {
    display: flex;
  }

  &:not(:first-of-type) {
    margin-top: 3em;
  }
`;

export const EditLink = styled.div`
  font-size: 12px;
  margin-top: 5px;
  font-weight: 700;
  color: ${(props: any) => props.theme.carvana.blue.primary};
  :hover {
    color: ${(props: any) => props.theme.carvana.blue.hover};
  }
  cursor: pointer;
`;

export const TextDisclaimer = styled.p`
  font-size: 14px;
  color: ${(props: any) => props.theme.carvana.gray.dark};
`;

export const InlineLink = styled.div`
  display: inline;
  color: ${(props: any) => props.theme.carvana.blue.primary};
  :hover {
    color: ${(props: any) => props.theme.carvana.blue.hover};
  }
  cursor: pointer;
`;
